var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiReviewWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 16.499H12.625C12.8839 16.499 13.0938 16.2891 13.0938 16.0303V2.87402C13.0938 2.61515 12.8839 2.40527 12.625 2.40527H11.2188V0.967773C11.2188 0.708898 11.0089 0.499023 10.75 0.499023H1.375C1.11612 0.499023 0.90625 0.708898 0.90625 0.967773V14.1553C0.90625 14.4141 1.11612 14.624 1.375 14.624H2.78125V16.0303C2.78125 16.2891 2.99113 16.499 3.25 16.499ZM11.2188 14.1553V3.34277H12.1562V15.5615H3.71875V14.624H10.75C11.0089 14.624 11.2188 14.4141 11.2188 14.1553ZM1.84375 13.6865V1.43652H10.2812V13.6865H1.84375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 4.28027H6.0625C6.32137 4.28027 6.53125 4.0704 6.53125 3.81152C6.53125 3.55265 6.32137 3.34277 6.0625 3.34277H3.25C2.99112 3.34277 2.78125 3.55265 2.78125 3.81152C2.78125 4.0704 2.99112 4.28027 3.25 4.28027Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 5.21777H3.25C2.99112 5.21777 2.78125 5.42765 2.78125 5.68652C2.78125 5.9454 2.99112 6.15527 3.25 6.15527H8.875C9.13387 6.15527 9.34375 5.9454 9.34375 5.68652C9.34375 5.42765 9.13387 5.21777 8.875 5.21777Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 7.09277H3.25C2.99112 7.09277 2.78125 7.30265 2.78125 7.56152C2.78125 7.8204 2.99112 8.03027 3.25 8.03027H8.875C9.13387 8.03027 9.34375 7.8204 9.34375 7.56152C9.34375 7.30265 9.13387 7.09277 8.875 7.09277Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 8.96777H3.25C2.99112 8.96777 2.78125 9.17765 2.78125 9.43652C2.78125 9.6954 2.99112 9.90527 3.25 9.90527H8.875C9.13387 9.90527 9.34375 9.6954 9.34375 9.43652C9.34375 9.17765 9.13387 8.96777 8.875 8.96777Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 10.8428H7C6.74112 10.8428 6.53125 11.0526 6.53125 11.3115C6.53125 11.5704 6.74112 11.7803 7 11.7803H8.875C9.13387 11.7803 9.34375 11.5704 9.34375 11.3115C9.34375 11.0526 9.13387 10.8428 8.875 10.8428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiReviewWhite);
export default __webpack_public_path__ + "static/media/kpi_review_white.c802409a75446b0bece6649a186bc590.svg";
export { ForwardRef as ReactComponent };